import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PciModeloItemConta'

const GetItems = (companyId, accountId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${companyId}/conta/${accountId}`, data, config)
const SaveItemsPermissions = (companyId, accountId, data, config = {}) => APIClient.post(`${APIPci}/${resourceName}/${companyId}/conta/${accountId}`, data, config)

const AccountPciItemModelRepository = {
  GetItems,
  SaveItemsPermissions
}

export default AccountPciItemModelRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pcimodeloitemconta.js